<template>
  <div class="flex-box">
    <div class="search-box">
      <el-button type="primary" icon="el-icon-refresh" @click="GetData()">刷新列表</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="role" label="角色ID" width="100" align="center"></el-table-column>
      <el-table-column prop="roleName" label="角色名称" width="160" align="center"></el-table-column>
      <el-table-column label="权限" min-width="280">
        <template slot-scope="scope">
          <el-tree :data="getTreeData(scope.row.menuAccess)" accordion></el-tree>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('A30501')" type="primary" size="mini" plain @click="openDialog(scope.row)">授权</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog title="角色访问权限" :visible.sync="dialogVisible" width="70%">
      <div v-for="item in selectMenus" :key="item.tag" class="role-div1">
        <el-checkbox class="checkbox-1" v-model="item.visible">{{ item.name }}</el-checkbox>
        <div v-for="item2 in (item.list || [])" :key="item2.tag" class="role-div2">
          <el-checkbox class="checkbox-2" v-model="item2.visible">{{ item2.name }}</el-checkbox>
          <div class="role-div3">
            <el-checkbox v-for="item3 in (item2.list || [])" :key="item3.tag" v-model="item3.visible">{{ item3.name }}</el-checkbox>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      queryParams: { pageIndex: 1, pageSize: 10 },
      sourceList: [],
      tableData: [],
      dialogVisible: false,
      selectRole: { role: 0, roleName: '', menuAccess: '' },
      selectMenus: [],
      powerList: []
    }
  },
  created() {
    this.GetData()
    this.GetPowerList()
  },
  methods: {
    GetData() {
      const loading = this.openLoading()
      post(218, {})
        .then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.sourceList = Array.isArray(response.data.data) ? response.data.data : []
            this.applyMockPage(this.sourceList)
          } else {
            this.sourceList = []
            this.applyMockPage([])
            this.$message.error('查询数据失败:' + response.data.message)
          }
        })
        .catch(error => {
          loading.close()
          this.sourceList = []
          this.applyMockPage([])
          this.$message.error((error && error.userMessage) || '查询数据失败')
        })
    },
    GetPowerList() {
      const loading = this.openLoading()
      post(217, {})
        .then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.powerList = Array.isArray(response.data.data) ? response.data.data : []
          } else {
            this.powerList = []
            this.$message.error('查询数据失败:' + response.data.message)
          }
        })
        .catch(error => {
          loading.close()
          this.powerList = []
          this.$message.error((error && error.userMessage) || '查询数据失败')
        })
    },
    handleCurrentChange() {
      this.applyMockPage(this.sourceList)
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.queryParams.pageIndex = 1
      this.applyMockPage(this.sourceList)
    },
    parseMenuAccess(menuAccess) {
      if (!menuAccess) return []
      if (Array.isArray(menuAccess)) return menuAccess
      if (typeof menuAccess === 'string') {
        const text = menuAccess.trim()
        if (!text) return []
        try {
          const parsed = JSON.parse(text)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    getTreeData(menuAccess) {
      const data = []
      const menus = this.parseMenuAccess(menuAccess)
      for (const item of menus) {
        const menu = { label: item.name, children: [] }
        for (const item2 of (item.list || [])) {
          const menu2 = { label: item2.name, children: [] }
          for (const item3 of (item2.list || [])) {
            if (item3.visible) {
              menu2.children.push({ label: item3.name })
            }
          }
          if (item2.visible) {
            menu.children.push(menu2)
          }
        }
        if (item.visible) {
          data.push(menu)
        }
      }
      return data
    },
    GetVisible(tag) {
      let result = false
      const walk = (nodes) => {
        if (!Array.isArray(nodes)) return
        nodes.forEach(item => {
          if (item.tag == tag) result = !!item.visible
          walk(item.list)
        })
      }
      walk(this.selectMenus)
      return result
    },
    openDialog(row) {
      if (!row) return
      if (!this.powerList.length) {
        this.$message.warning('权限菜单尚未加载完成，请稍后重试')
        this.GetPowerList()
        return
      }
      this.selectRole = JSON.parse(JSON.stringify(row))
      this.selectMenus = this.parseMenuAccess(this.selectRole.menuAccess)
      const powerList = JSON.parse(JSON.stringify(this.powerList))
      powerList.forEach(item => {
        item.visible = this.GetVisible(item.tag)
        ;(item.list || []).forEach(item2 => {
          item2.visible = this.GetVisible(item2.tag)
          ;(item2.list || []).forEach(item3 => {
            item3.visible = this.GetVisible(item3.tag)
          })
        })
      })
      this.selectMenus = powerList
      this.dialogVisible = true
    },
    submitForm() {
      const loading = this.openLoading()
      post(219, {
        role: this.selectRole.role,
        menuAccess: JSON.stringify(this.selectMenus)
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.dialogVisible = false
          this.$message.success('修改成功')
          this.GetData()
        } else {
          this.$message.error('操作失败:' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || '操作失败')
      })
    }
  }
}
</script>

<style>
.role-div1 {
  border: 2px solid #666;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 5px;
}
.role-div2 {
  border: 1px solid #ddd;
  margin-left: 40px;
  margin-bottom: 10px;
  padding-left: 10px;
  border-radius: 5px;
}
.role-div3 { margin-left: 40px; }
.checkbox-1 { font-weight: 900; }
</style>
